import React from 'react'
import BarraSuperiorEsquerda from '../barraSuperior/BarraSuperiorEsquerda'
import SomenteDesktop from './SomenteDesktop'
import useTelaPequena from './useTelaPequena'

/**
 * Rota de configuração não adaptada ao celular (padrão P-C7, onda O2): no celular mostra a barra do app e o aviso
 * "disponível no computador"; no desktop, a tela normal. Usado no App.js em volta da tela.
 *
 * @param {{ titulo: string, children: any }} props
 */
export default function ConfiguracaoSomenteDesktop({ titulo, children }) {
  const telaPequena = useTelaPequena()
  if (!telaPequena) return children
  return (
    <>
      <BarraSuperiorEsquerda />
      <SomenteDesktop titulo={titulo}>{null}</SomenteDesktop>
    </>
  )
}
